import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GlobalMessageType, isErrorGloballyHandled } from '../../../global-message';
import { GlobalMessageActions } from '../../../global-message/store';
import { ErrorModel } from '../../../model';
import { normalizeHttpError } from '../../../util';
import { AppActions } from '../../../util/store/actions';
import { CompanyConnector } from '../../connectors/company-connector';
import { UserActions } from '../actions';

@Injectable()
export class CompanyEffects {
  searchCompany$: Observable<UserActions.SearchCompanySuccess | UserActions.SearchCompanyFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.CompanyActionTypes.SearchCompany),
      map((action: UserActions.SearchCompany) => action.payload),
      switchMap((company) =>
        this.connector.searchSignupWorksites(company).pipe(
          map((data) => new UserActions.SearchCompanySuccess(data)),
          catchError((error) => of(new UserActions.SearchCompanyFail(normalizeHttpError(error))))
        )
      )
    )
  );

  loadCompanyByCompanyId$: Observable<UserActions.LoadCompanySuccess | UserActions.LoadCompanyFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.CompanyActionTypes.LoadCompany),
      switchMap((action: UserActions.LoadCompany) =>
        this.connector.getSignupWorksiteByCompanyId(action.id, action.companySearchServiceType).pipe(
          map((data) => new UserActions.LoadCompanySuccess(data)),
          catchError((error) => of(new UserActions.LoadCompanyFail(normalizeHttpError(error))))
        )
      )
    )
  );

  handleFailureForLoadCompanyByCompanyId$: Observable<GlobalMessageActions.AddMessage | AppActions.NoOpAction> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserActions.CompanyActionTypes.LoadCompanyFail),
        map((action: UserActions.LoadCompanyFail) => action.payload),
        switchMap((payload) => {
          if (!isErrorGloballyHandled(payload?.status)) {
            if (Array.isArray(payload?.details)) {
              const messageActionsArray: GlobalMessageActions.AddMessage[] = payload.details
                .filter((errorDetail: ErrorModel) => errorDetail.message)
                .map((errorDetail: ErrorModel) => {
                  return new GlobalMessageActions.AddMessage({
                    text: { raw: errorDetail.message },
                    type: GlobalMessageType.MSG_TYPE_ERROR,
                  });
                });

              if (messageActionsArray.length) {
                return messageActionsArray;
              }
            }
            return [
              new GlobalMessageActions.AddMessage({
                text: { key: 'registration.companyDetailsLookupFailure_message' },
                type: GlobalMessageType.MSG_TYPE_ERROR,
              }),
            ];
          } else {
            return [new AppActions.NoOpAction()];
          }
        })
      )
  );

  constructor(private actions$: Actions, private connector: CompanyConnector) {}
}
